<!-- <app-navbar></app-navbar> -->
<!-- <app-sidebar></app-sidebar> -->
<app-hire-sidebar></app-hire-sidebar>
<div class="row">
  <div class="col-md-3 pr-0 topsticky2">
    <div class="">
      <!-- <app-report-filters [talentdata]="talentfilterdata" (filterEvent)="getfiltesdata($event)"></app-report-filters> -->
      <app-report-filters></app-report-filters>
    </div>
  </div>
  <div class="col-md-9">
    <div class="row mb-1">
      <div class="wccard mx-3 col d-flex justify-content-between align-items-start headerbg">
        <div class="py-3">
          <p class="f-18 font-weight-600 mb-1">Talent Pool Report</p>
          <p class="f-14 text-9696"   matTooltip="Total Talent Count : {{totalcount}}"
                  [matTooltipClass]="{ 'red-tooltip': true }">{{formatNumberToIndianFormat(totalcount)}} Talents Identified</p>
        </div>
        <div class="my-3" *ngIf="isComingFromJD || isComingFromNLSearch">
          <button data-testid="auto-app-report-details-button-1" class="jd-edit-btn" (click)="editSimilarCandidateFilters()"><i class="far fa-edit mr-1"></i>
            JD Parameters
            ({{jdDataService.countOfJDFilterApplied}})
          </button>
        </div>
      </div>
    </div>
    <!-- <div class="row mb-2">
      <div class="col"> -->
        <div class="wccard mb-1 topsticky">
          <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
              <a data-testid="auto-app-report-details-a-1" class="nav-link" [ngClass]="{ active: isTabActive('report-overview') }"  routerLink="report-overview" [queryParams]="queryParams">
                Overview
              </a>
              <a data-testid="auto-app-report-details-a-2" class="nav-link" [ngClass]="{ active: isTabActive('report-location') }" routerLink="report-location" [queryParams]="queryParams">
                Location
              </a>
              <a data-testid="auto-app-report-details-a-3" class="nav-link" [ngClass]="{ active: isTabActive('report-company') }" routerLink="report-company" [queryParams]="queryParams">
                Company
              </a>
              <a data-testid="auto-app-report-details-a-4" class="nav-link" [ngClass]="{ active: isTabActive('report-education') }" routerLink="report-education" [queryParams]="queryParams">
                  Education
                </a>


                <a data-testid="auto-app-report-details-a-5" class="nav-link" [ngClass]="{ active: isTabActive('report-skills') }" routerLink="report-skills" [queryParams]="queryParams">
                  Skills
                </a>
                <a data-testid="auto-app-report-details-a-6" class="nav-link" [ngClass]="{ active: isTabActive('report-industries') }" routerLink="report-industries" [queryParams]="queryParams">
                  Industries
                </a>
                <a data-testid="auto-app-report-details-a-7" class="nav-link" [ngClass]="{ active: isTabActive('report-titles') }" routerLink="report-titles" [queryParams]="queryParams">
                  Titles
                </a>
                <a data-testid="auto-app-report-details-a-8" class="nav-link" [ngClass]="{ active: isTabActive('report-profiles') }" routerLink="report-profiles" [queryParams]="queryParams">
                  Profiles
                  </a>

                <a data-testid="auto-app-report-details-a-9" class="nav-link" [ngClass]="{ active: isTabActive('report-diversity') }" routerLink="report-diversity" [queryParams]="queryParams">
                  Diversity
                  </a>

            </ul>
      </div>
      <!-- </div>
    </div> -->
    <div class="tab-content">
      <div class="tab-pane fade show active">
          <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
